"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_native_svg_1 = __importStar(require("react-native-svg"));
function SvgComponent(props) {
    return (React.createElement(react_native_svg_1.default, Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none" }, props),
        React.createElement(react_native_svg_1.Path, { d: "M8.009 3.887A4.1 4.1 0 003.904 7.99a4.1 4.1 0 004.105 4.105 4.1 4.1 0 004.104-4.105A4.112 4.112 0 008.01 3.887zm0 6.774a2.674 2.674 0 01-2.67-2.67A2.659 2.659 0 018.01 5.34 2.643 2.643 0 0110.66 7.99c0 1.471-1.18 2.67-2.651 2.67z", fill: "#F15A22" }),
        React.createElement(react_native_svg_1.Path, { d: "M11.295.054c-1.47-.072-5.121-.072-6.592 0-1.29.055-2.434.364-3.36 1.29C-.183 2.888-.001 4.958-.001 7.99c0 3.106-.182 5.14 1.344 6.647 1.544 1.544 3.65 1.344 6.647 1.344 3.087 0 4.14 0 5.23-.418 1.49-.581 2.597-1.907 2.706-4.286.073-1.471.073-5.121 0-6.592-.109-2.797-1.616-4.504-4.63-4.632zM13.62 13.64c-1.017 1.017-2.415.926-5.648.926-3.342 0-4.668.055-5.648-.926-1.126-1.126-.927-2.906-.927-5.63.019-3.705-.363-6.356 3.342-6.556.854-.036 1.108-.036 3.233-.036l.036.018c3.56 0 6.338-.363 6.502 3.323.036.836.054 1.09.054 3.233 0 3.305.055 4.65-.944 5.648z", fill: "#F15A22" }),
        React.createElement(react_native_svg_1.Path, { d: "M12.277 4.685a.963.963 0 100-1.925.963.963 0 000 1.925z", fill: "#F15A22" })));
}
exports.default = SvgComponent;
